import { useEffect, useState } from "react";

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 640);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 w-12 h-12 flex items-center justify-center rounded-full bg-primary-900 text-background-50 hover:bg-primary-800 cursor-pointer transition-colors shadow-lg"
      aria-label="回到顶部"
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}